//--------------- IMPORTAÇÕES ---------------//
import api from "../../../shared/services/api";
import { toast } from "react-toastify";


//--------------- FUNÇÃO ASSÍNCRONA SALVAR EMPRESA ---------------//
// Responsável por salvar a empresa criada via API
export default async function associateTagService(idLead, idTag) {
    try {
        console.log(idLead)
        console.log(idTag);
        await api.post(`/leads/${idLead}/tags`, {tag_id: idTag} );
        toast.success("Tag associada com sucesso");
        return true;
    } catch {
        toast.error("Erro ao associar tag");
        return false;
    }
}